import React from 'react';

export const applicationStatusList = {
	success: {
		title: 'Благодарим за заявку',
		text: <>C вами свяжется менеджер для уточнения деталей</>,
		action: 'ОК',
	},

	duplicate: {
		title: 'Мы уже получили вашу заявку',
		text: (
			<>
				Скоро мы с вами свяжемся. <br />
				Пожалуйста, дождитесь ответа.
			</>
		),
		action: 'Хорошо',
	},
	error: {
		title: 'Ошибка',
		text: (
			<>
				Извините, что-то пошло не так. <br />
				Попробуйте позже.
			</>
		),
		action: 'ОК',
	},
};
